import { render, staticRenderFns } from "./DashboardLocked.vue?vue&type=template&id=61cf4ead&scoped=true"
import script from "./DashboardLocked.vue?vue&type=script&lang=js"
export * from "./DashboardLocked.vue?vue&type=script&lang=js"
import style0 from "./DashboardLocked.vue?vue&type=style&index=0&id=61cf4ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf4ead",
  null
  
)

export default component.exports